import { Currency } from '@/core/currency/interfaces';

const YER: Currency = {
    name: 'Yemeni Rial',
    demonym: 'Yemeni',
    majorSingle: 'Rial',
    majorPlural: 'Rials',
    codeNumeric: '886',
    symbol: 'YR',
    symbolNative: 'ر.ي.',
    minorSingle: 'Fils',
    minorPlural: 'Fils',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'YER',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default YER;
